import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { write } from "../firebase";

const storage = getStorage();


export const upload = (path, file) => {
  const storageRef = ref(storage, path);
  return uploadBytes(storageRef, file).then(snapshot => getDownloadURL(snapshot.ref))
}

export const create = (path, data) => {
  return write(path, {
    created_at: Date.now(),
    ...data
  })
}